import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import type { ServiceCta } from '../../data/services';
export function ServiceCtaLink({
  cta
}: {
  cta: ServiceCta;
}) {
  const internal = cta.href.startsWith('/');
  return <a href={cta.href} {...internal ? {} : {
    target: '_blank',
    rel: 'noopener noreferrer'
  }} className="focus-ring group inline-flex min-h-[44px] items-center gap-2 text-[14.5px] font-medium text-olive" data-id="element-257" data-mp="3qwmhwlcpok4p">
      <span className="border-b border-olive/35 pb-0.5 transition-colors duration-150 group-hover:border-olive" data-id="element-258" data-mp="3uwwzkv9v8yze">
        {cta.label}
      </span>
      {internal ? <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-259" data-mp="do08qh06rqrx" /> : <>
          <ArrowUpRightIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-260" data-mp="2fgxujsvjpj3d" />
          <span className="sr-only" data-id="element-261" data-mp="2ahtimuh8l79c">(opens in a new tab)</span>
        </>}
    </a>;
}